import styled from '@emotion/styled'

export const UserDetailContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
`

export const UserAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`

export const UserFallbackAvatar = styled.div<{ bgColor: string }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor};
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

export const UserName = styled.p`
  margin: 0;
  font-weight: 500;
`

export const UserGender = styled.span`
  font-size: 12px;
  color: #888;
`

export const DateTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const DateText = styled.p`
  font-weight: 500;
  margin: 0;
`

export const TimeText = styled.p`
  font-size: 12px;
  color: #888;
  margin: 0;
`
